import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { StyledFlex, StyledSubTitle, StyledTitle } from './Errors.styles';

const ErrorLayout = ({ title = 'Oops! Something went wrong.', children }) => {
  const intl = useIntl();
  return (
    <div>
      <StyledFlex>
        <StyledTitle>{title}</StyledTitle>
        <StyledSubTitle>
          {intl.formatMessage({
            id: 'app.errorBoundary.subTitle',
          })}
          &nbsp;
          <a href="mailto:servicedesk@ipc.be">servicedesk@ipc.be</a>
          &nbsp; or &nbsp;
          <a href="https://servicedesk.ipc.be/servicedesk">IPC Customer Service Desk Portal</a>
        </StyledSubTitle>
        {children}
      </StyledFlex>
    </div>
  );
};
ErrorLayout.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
};

export default ErrorLayout;
